/**
 * REST API base URL (`restful.api.*`). Set via `NEXT_PUBLIC_RESTFUL_API_URL`.
 * normalizes trailing slash.
 */
export const RESTFUL_API_BASE_URL =
  process.env.NEXT_PUBLIC_RESTFUL_API_URL?.replace(/\/$/, '');
